import { call, put, takeEvery } from "redux-saga/effects"

import { 
  GET_CATEGORIES_SUBCATEGORIES, 
  GET_HSNS,
  GET_UNITS,
  GET_ALLCOA,
  GET_ALL_PRODUCTS,
  GET_PRODUCT_FOR_EDIT,
  GET_MANUFACTURERS,
  GET_TAXES,
  GET_BRANDS,
  GET_SUPPLIERS,
  GET_ALL_CUSTOMERS,
  GET_ALL_EMPLOYEES,
  GET_ALL_BANKS,
  GET_SIZES,
  GET_COLOURS,
  ADD_NEW_ITEM ,
  ADD_NEW_MAJOR_ITEM,
  EDIT_ITEM,
  DELETE_ITEM,
  GET_SETTINGS,
  GET_LEDGER_DETAILS
} from "./actionTypes"

import {
  getCategoriesAndSubCategoriesSuccess,
  getCategoriesAndSubCategoriesFail,
  getAllSuppliersSuccess,
  getAllSuppliersFail,
  getAllCustomersSuccess,
  getAllCustomersFail,
  getAllEmployeesSuccess,
  getAllEmployeesFail,
  getAllBanksSuccess,
  getAllBanksFail,
  getAllBrandsSuccess,
  getAllBrandsFail,
  getAllTaxesSuccess,
  getAllTaxesFail,
  getAllManufacturersSuccess,
  getAllManufacturersFail,
  getAllUnitsSuccess,
  getAllUnitsFail,
  getAllCoasSuccess,
  getAllCoasFail,
  getAllProductsSuccess,
  getAllProductsFail,
  getProductForEditSuccess,
  getProductForEditFail,
  getAllHSNsSuccess,
  getAllHSNsFail,
  getAllSizesSuccess,
  getAllSizesFail,
  getAllColoursSuccess,
  getAllColoursFail,
  addNewItemSuccess,
  addNewItemFail,
  addNewMajorItemSuccess,
  addNewMajorItemFail,
  editItemSuccess,
  editItemFail,
  deleteItemSuccess,
  deleteItemFail,
  getStoreSettingsSuccess,
  getStoreSettingsFail,
  getLedgerDetailsSuccess,
  getLedgerDetailsFail
} from "./actions"

import {
  getCategoryAndSubCategory,
  addNewItem,
  getBrands,
  getHSNs,
  getTaxes,
  getUnits,
  getAllProducts,
  getProductForEdit,
  getSuppliers,
  getAllCustomers,
  getAllEmployees,
  getAllBanks,
  getColours,
  getSizes,
  getManufacturers,
  editItem,
  deleteItem,
  getStoreSettings,
  getLedgerDetails,
  getCoas
} from "helpers/backend_helper"

import {
  getStoreSettingsFromCache,
  getCOAListFromCache,
  getAllCustomersFromCache,
  getLedgerDetailsFromCache,
  getSuppliersFromCache,
  getSizesFromCache,
  getColoursFromCache,
  getBrandsFromCache,
  getHSNsFromCache,
  getTaxesFromCache,
  getUnitsFromCache,
  getManufacturersFromCache,
  getCategoryAndSubCategoryFromCache
} from "helpers/cache_helper"

function* fetchLedgerDetails({ payload: { type }, fromCache}) {
  try {
    const response = yield call(getLedgerDetailsFromCache, type, fromCache)
    yield put(getLedgerDetailsSuccess(response))
  } catch (error) {
    yield put(getLedgerDetailsFail(error))
  }
}

function* fetchStoreSettings({ payload }) {
  try {
    const response = yield call(getStoreSettingsFromCache, payload)
    yield put(getStoreSettingsSuccess(response))
  } catch (error) {
    yield put(getStoreSettingsFail(error))
  }
}

function* fetchSizes({ payload }) {
  try {
    const response = yield call(getSizesFromCache, payload)
    yield put(getAllSizesSuccess(response))
  } catch (error) {
    yield put(getAllSizesFail(error))
  }
}

function* fetchColours({ payload }) {
  try {
    const response = yield call(getColoursFromCache, payload)
    yield put(getAllColoursSuccess(response))
  } catch (error) {
    yield put(getAllColoursFail(error))
  }
}

function* fetchSuppliers({payload}) {
  try {
    const response = yield call(getSuppliersFromCache, payload)
    yield put(getAllSuppliersSuccess(response))
  } catch (error) {
    yield put(getAllSuppliersFail(error))
  }
}

function* fetchCustomers({payload}) {
  try {
    const response = yield call(getAllCustomersFromCache, payload)
    yield put(getAllCustomersSuccess(response))
  } catch (error) {
    yield put(getAllCustomersFail(error))
  }
}

function* fetchEmployees() {
  try {
    const response = yield call(getAllEmployees)
    yield put(getAllEmployeesSuccess(response))
  } catch (error) {
    yield put(getAllEmployeesFail(error))
  }
}

function* fetchBanks() {
  try {
    const response = yield call(getAllBanks)
    yield put(getAllBanksSuccess(response))
  } catch (error) {
    yield put(getAllBanksFail(error))
  }
}

function* fetchBrands({payload}) {
  try {
    const response = yield call(getBrandsFromCache,payload)
    yield put(getAllBrandsSuccess(response))
  } catch (error) {
    yield put(getAllBrandsFail(error))
  }
}

function* fetchTaxes({payload}) {
  try {
    const response = yield call(getTaxesFromCache, payload)
    yield put(getAllTaxesSuccess(response))
  } catch (error) {
    yield put(getAllTaxesFail(error))
  }
}

function* fetchManufacturers({payload}) {
  try {
    const response = yield call(getManufacturersFromCache, payload)
    yield put(getAllManufacturersSuccess(response))
  } catch (error) {
    yield put(getAllManufacturersFail(error))
  }
}

function* fetchUnits({payload}) {
  try {
    const response = yield call(getUnitsFromCache, payload)
    yield put(getAllUnitsSuccess(response))
  } catch (error) {
    yield put(getAllUnitsFail(error))
  }
}

function* fetchCoas({payload}) {
  try {
    const response = yield call(getCOAListFromCache, payload)
    yield put(getAllCoasSuccess(response))
  } catch (error) {
    yield put(getAllCoasFail(error))
  }
}

function* fetchProducts() {
  try {
    const response = yield call(getAllProducts)
    yield put(getAllProductsSuccess(response))
  } catch (error) {
    yield put(getAllProductsFail(error))
  }
}

function* fetchProductDetailForEdit({productid}) {
  try {
    const response = yield call(getProductForEdit, productid)
    yield put(getProductForEditSuccess(response))
  } catch (error) {
    yield put(getProductForEditFail(error))
  }
}

function* fetchHSNs({payload}) {
  try {
    const response = yield call(getHSNsFromCache,payload)
    yield put(getAllHSNsSuccess(response))
  } catch (error) {
    yield put(getAllHSNsFail(error))
  }
}

function* fetchCategories({payload}) {
  try {
    const response = yield call(getCategoryAndSubCategoryFromCache, payload)
    yield put(getCategoriesAndSubCategoriesSuccess(response))
  } catch (error) {
    yield put(getCategoriesAndSubCategoriesFail(error))
  }
}

function* submitAddNewItem({ payload: { item, type }}) {
  try {
    const response = yield call(addNewItem,item,type)
    let responseParsed = JSON.parse(JSON.stringify(response))
    if(responseParsed && responseParsed.status && responseParsed.status == 'success'){
      yield put(addNewItemSuccess(responseParsed))
    }
    else{
      yield put(addNewItemFail(responseParsed))
    }
  } catch (error) {
    yield put(addNewItemFail(error))
  }
}

function* submitAddNewMajorItem({ payload: { item, type }}) {
  try {
    const response = yield call(addNewItem,item,type)
    let responseParsed = JSON.parse(JSON.stringify(response))
    if(responseParsed && responseParsed.status && responseParsed.status == 'success'){
      yield put(addNewMajorItemSuccess(responseParsed))
    }
    else{
      yield put(addNewMajorItemFail(responseParsed))
    }
  } catch (error) {
    yield put(addNewMajorItemFail(error))
  }
}

function* submitEditItem({ payload: { item, type }}) {
  try {
    const response = yield call(editItem,item,type)
    let responseParsed = JSON.parse(JSON.stringify(response))
    if(responseParsed && responseParsed.status && responseParsed.status == 'success'){
      yield put(editItemSuccess(responseParsed))
    }
    else{
      yield put(editItemFail(responseParsed))
    }
  } catch (error) {
    yield put(editItemFail(error))
  }
}

function* submitDeleteItem({ payload: { item, type }}) {
  try {
    const response = yield call(deleteItem,item,type)
    let responseParsed = JSON.parse(JSON.stringify(response))
    if(responseParsed && responseParsed.status && responseParsed.status == 'success'){
      yield put(deleteItemSuccess(responseParsed))
    }
    else{
      yield put(deleteItemFail(responseParsed))
    }
  } catch (error) {
    yield put(deleteItemFail(error))
  }
}

function* productSaga() {
  yield takeEvery(GET_CATEGORIES_SUBCATEGORIES, fetchCategories)
  yield takeEvery(GET_HSNS, fetchHSNs)
  yield takeEvery(GET_UNITS, fetchUnits)
  yield takeEvery(GET_ALL_PRODUCTS, fetchProducts)
  yield takeEvery(GET_PRODUCT_FOR_EDIT, fetchProductDetailForEdit)
  yield takeEvery(GET_MANUFACTURERS, fetchManufacturers)
  yield takeEvery(GET_TAXES, fetchTaxes)
  yield takeEvery(GET_BRANDS, fetchBrands)
  yield takeEvery(GET_SUPPLIERS, fetchSuppliers)
  yield takeEvery(GET_COLOURS, fetchColours)
  yield takeEvery(GET_SIZES, fetchSizes)
  yield takeEvery(ADD_NEW_ITEM, submitAddNewItem)
  yield takeEvery(ADD_NEW_MAJOR_ITEM, submitAddNewMajorItem)
  yield takeEvery(EDIT_ITEM, submitEditItem)
  yield takeEvery(DELETE_ITEM, submitDeleteItem)
  yield takeEvery(GET_SETTINGS, fetchStoreSettings)
  yield takeEvery(GET_LEDGER_DETAILS, fetchLedgerDetails)
  yield takeEvery(GET_ALL_CUSTOMERS, fetchCustomers)
  yield takeEvery(GET_ALL_EMPLOYEES, fetchEmployees)
  yield takeEvery(GET_ALL_BANKS, fetchBanks)
  yield takeEvery(GET_ALLCOA, fetchCoas)
  
  
}

export default productSaga
